export enum StorageKeys {
  uid = '_d',
  lang = 'lang',
}
